export enum FamilyCategory
{
    Unknown = 0,
    Panel = 1,
    Beam = 2,
    Joint = 3,
    Unspecified = 4
}